import KeyboardVoiceOutlinedIcon from "@mui/icons-material/KeyboardVoiceOutlined";
import { Box } from "@mui/material";
import DisplayAudio from "../../../common/DisplayAudio";
import { IMessageContentTypeBubble } from "../../MessagePanel";

const AudioContent = ({ message }: IMessageContentTypeBubble) => {
  const voiceMessage = message.getMessage().voiceMessage;
  return (
    <>
      {voiceMessage?.url && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "15px",
            height: "54px",
            width: "350px",
          }}
        >
          <KeyboardVoiceOutlinedIcon fontSize="large" />
          <DisplayAudio url={voiceMessage.url} />
        </Box>
      )}
    </>
  );
};

export default AudioContent;
